import { uploadState } from "@/constants/attachment";
import { TFunction } from "i18next";

export const getAttachmentValidator = (t: TFunction<"validations">, requiredMessage?: string) => ({
  uploaded: (value: uploadState, required = false) => {
    if (value === "noFiles" && required) {
      return requiredMessage ?? t("requiredAttachment");
    }
    if (value === "uploadInProgress") {
      return t("uploadInProgress");
    }
    return null;
  },
});
